import healoLogoLight from "@/assets/healo-logo.png";
import healoLogoDark from "@/assets/healo-logo-dark.png";
import { cn } from "@/lib/utils";

/**
 * Healo mark for in-app patient threads (metadata.conversationType === "app") — the channel
 * badge sibling of WhatsappThreadGlyph. Renders both theme PNGs and toggles with CSS
 * (`.dark` on <html>), mirroring components/healo-logo.jsx; both assets are square so a
 * size-3 slot doesn't distort.
 */
export function HealoChannelGlyph({ className = "" }) {
  return (
    <>
      <img src={healoLogoLight} alt="" aria-hidden className={`${className} dark:hidden`.trim()} />
      <img src={healoLogoDark} alt="" aria-hidden className={`${className} hidden dark:block`.trim()} />
    </>
  );
}

/**
 * WhatsApp brand mark (currentColor, brand green by default) — shared channel-selector
 * sibling of HealoChannelGlyph for surfaces that offer both channels.
 */
export function WhatsappChannelGlyph({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={cn("text-green-500", className)}
      aria-hidden
      focusable="false"
    >
      <path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.6-2.7-1.2-4.4-3.9-4.6-4.1-.1-.2-1.1-1.4-1.1-2.7 0-1.3.7-1.9.9-2.2.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5-.1.2-.2.3-.3.4l-.4.4c-.1.1-.3.3-.1.5.2.3.8 1.2 1.7 2 1.1 1 2 1.3 2.3 1.4.3.1.4.1.6-.1.2-.2.7-.8.9-1.1.2-.3.4-.2.6-.1.3.1 1.8.9 2.1 1 .3.2.5.2.6.4.1.2.1.8-.1 1.4z" />
    </svg>
  );
}
